module.exports = __webpack_public_path__ + "img/havanna_oak_696l_detail_rsh1.4e65b1bb.jpg";